import { AssigneeCallHistoryWidget } from "./assignee-call-history/AssigneeCallHistoryWidget"
import { AssigneeCallVolumeWidget } from "./assignee-call-volume/AssigneeCallVolumeWidget"
import type { BaseWidget } from "./BaseWidget"
import { ChartWidget } from "./chart/ChartWidget"
import { TableWidget } from "./TableWidget"
import { TextWidget } from "./TextWidget"

export class WidgetRegistry {
  private static widgets: Map<string, BaseWidget> = new Map()

  static {
    this.register(new ChartWidget())
    this.register(new TextWidget())
    this.register(new TableWidget())
    this.register(new AssigneeCallVolumeWidget())
    this.register(new AssigneeCallHistoryWidget())
  }

  private static register(widget: BaseWidget): void {
    this.widgets.set(widget.type, widget)
  }

  static getWidget(type: string): BaseWidget | undefined {
    return this.widgets.get(type)
  }

  static getAllWidgets(): BaseWidget[] {
    return Array.from(this.widgets.values())
  }

  static getWidgetTemplates() {
    return this.getAllWidgets().map((widget) => widget.getTemplate())
  }

  static hasWidget(type: string): boolean {
    return this.widgets.has(type)
  }
}
